import styled from 'styled-components';

const TableHeader = styled.div`
  padding: ${(props): string =>
    `${props.theme.spaces.md} ${props.theme.spaces.xl}`};
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props): string => props.theme.colors.paleBlue};
  position: sticky;
  left: 0;

  > :first-child {
    width: 32%;
  }
`;

export { TableHeader };
